import { render, staticRenderFns } from "./IcoService.vue?vue&type=template&id=edcdc5fa&scoped=true"
import script from "./IcoService.vue?vue&type=script&lang=js"
export * from "./IcoService.vue?vue&type=script&lang=js"
import style0 from "./IcoService.vue?vue&type=style&index=0&id=edcdc5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcdc5fa",
  null
  
)

export default component.exports